import React, { useEffect, useState } from "react";

import { useMsal } from "@azure/msal-react";

import {
  Button,
  Dialog,
  DialogContent,
  Slide,
  Grid,
  Divider,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import apiCall from "../utils/apiCall";
import { UPDATE_USER_SETTINGS } from "../endpoint";

import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";
import { addUserDetails, getuser } from "../redux/slices/userSlice";
import { getModelDetails } from "../redux/slices/modelSlice";
import TemperatureSlider from "./Slider";
import SettingRow from "./SettingRow";
import Loader from "./Loader";
import { addError } from "../redux/slices/errorSlice";
import { Close } from "@mui/icons-material";
import { StyledTooltip } from "./StyledTooltip";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ISettingModal {
  open: boolean;
  setOpen: any;
}

const SettingsModal = ({ open, setOpen }: ISettingModal) => {
  const { accounts } = useMsal();
  const accountId = accounts[0]?.username;
  const user = useAppSelector(getuser);
  const [tempvalue, setTempvalue] = useState(user?.temp || 0);
  const [chunk_size, setChunk_size] = useState(user?.chunk_size);
  const [loading, setLoading] = useState(false);
  const model = useAppSelector(getModelDetails);
  useEffect(() => {
    setChunk_size(user?.chunk_size);
  }, [user?.chunk_size]);
  
  useEffect(() => {
    setTempvalue(user?.temp || 0);
  }, [user?.temp]);

  const dispatch = useAppDispatch();

  const handleClose = () => {
    setOpen(false);
  };
  const updateSettings = () => {
    setLoading(true);
    apiCall("POST", UPDATE_USER_SETTINGS, {
      temp: tempvalue,
      chunk_size: chunk_size,
      model: model?.model,
      user_email: accountId,
    })
      .then((res) => {
        dispatch(addUserDetails(res?.result));
        handleClose();
      })
      .catch((err) => {
        dispatch(addError("Failed to update the settings.Please try again."));
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
      {" "}
      <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: "absolute",
          right: 2,
          top: 2,
        }}
      >
        <Close sx={{ color: "gray" }} fontSize="small" />
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        {user?.user_name !== "" && (
          <>
            <Divider
              sx={{
                mb: 4,
              }}
            >
              <Typography
                fontWeight="bolder"
                sx={{
                  fontSize: "18px",
                }}
              >
                Update User Settings
              </Typography>
            </Divider>
            <SettingRow
              title={
                <StyledTooltip
                  title={"Use tempreature to control randomness of text.Higher = more creative, lower = more focused."} placement="left"
                  arrow
                >
                  <Typography component="span" sx={{ fontWeight: "bold" }}>Temperature</Typography>
                </StyledTooltip>
              }
            >
              <Grid item flex={1}>
                <TemperatureSlider
                  testid="TemperatureSlider"
                  setValue={setTempvalue}
                  default_value={0}
                  max={1}
                  min={0}
                  step={0.1}
                  value={tempvalue}
                />
              </Grid>
              <Typography
                sx={{
                  ml: 1,
                }}
              >
                {tempvalue}
              </Typography>
            </SettingRow>
            <SettingRow title="No. of Top Ranked Pages">
              <Grid item flex={1}>
                <TemperatureSlider
                  testid="RankedSlider"
                  setValue={setChunk_size}
                  default_value={chunk_size}
                  max={50}
                  min={1}
                  step={1}
                  value={chunk_size}
                />
              </Grid>
              <Typography
                sx={{
                  ml: 1,
                }}
              >
                {chunk_size}
              </Typography>
            </SettingRow>

            {loading && <Loader />}
            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 4 }}
              onClick={updateSettings}
              color="primary"
              disabled={loading}
              data-testid="settings-button"
            >
              Update Settings
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SettingsModal;
